import { Grid, Paper } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainMenu from "../../components/MainMenu";
import SeasonList from "../../components/SeasonManagementComponent/SeasonList";

const SeasonManagement = () => {
  
  const { role } = useSelector((state) => state.userDetailsReducer);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (role !== "super") {
  //     return navigate("/");
  //   }
  // }, []);

  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <SeasonList />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default SeasonManagement;
